import {observer} from 'mobx-react-lite'
import React from 'react'
import tw from 'tailwind-styled-components'
import {useTimelineNewStore} from '@components/timeline-new/timeline-new-store'

const TwVerticalStripes = tw.div`
  pointer-events-none
  overflow-hidden
  absolute
  top-0
  bottom-0
  left-0
  right-0
`

const TwVerticalStripe = tw.div`
  absolute
  top-0
  bottom-0
`

const TwWeekend = tw(TwVerticalStripe)`
  bg-acid-red
  opacity-[0.03]
`

const TwInterval = tw(TwVerticalStripe)`
  shadow-border-l-1
  shadow-line-base
`

export const WeekendStripes = observer(({className}: {className?: string}) => {
  const [state, store] = useTimelineNewStore()

  return (
    <TwVerticalStripes ref={store.addStripeContainerEl} className={className}>
      {state.weekendStripes.map(x => (
        <TwWeekend
          key={x.timestamp}
          style={{
            transform: `translate(${store.timeToPosition(x.timestamp)}px,0px)`,
            width: store.intervalToDistance(x.length)
          }}
        />
      ))}
    </TwVerticalStripes>
  )
})

export const IntervalStripes = observer(({className}: {className?: string}) => {
  const [state, store] = useTimelineNewStore()

  return (
    <TwVerticalStripes ref={store.addStripeContainerEl} className={className}>
      {state.intervalStripes.map(x => (
        <TwInterval
          key={x.timestamp}
          style={{
            transform: `translate(${store.timeToPosition(x.timestamp)}px,0px)`,
            width: store.intervalToDistance(x.length)
          }}
        />
      ))}
    </TwVerticalStripes>
  )
})
